
import React from "react";
import "./FabricChange.css";

import {
  FaWhatsapp,
  FaPhone,
  FaArrowRight,
  FaCheckCircle,
  FaCut,
  FaCouch,
  FaPalette,
  FaShieldAlt,
} from "react-icons/fa";

import Footer from "../footer/Footer";
import Location from "../location/Location";
import Navbar from "../navbar/Navbar";
import Offer from "../offer/Offer";
import Review from "../review/Review";

export default function FabricChange() {
  const WHATSAPP = "919318333680";
  const PHONE = "+919318333680";

  /* ================= FABRIC COLLECTION ================= */

  const fabric = [
    {
      title: "Leatherette",
      src: "/img/Leatherette_img.jpg",
      alt: "Leatherette fabric for sofa",
    },
    {
      title: "Velvet",
      src: "/img/valvet_img.jpg",
      alt: "Velvet fabric for sofa",
    },
    {
      title: "Linen",
      src: "/img/linen_img.jpg",
      alt: "Linen fabric for sofa",
    },
    {
      title: "Chenille",
      src: "/img/chanelli_img.jpg",
      alt: "Chenille fabric for sofa",
    },
    {
      title: "Suede",
      src: "/img/suede.webp",
      alt: "Suede fabric for sofa",
    },
    {
      title: "Cotton",
      src: "/img/cotton_img.jpg",
      alt: "Cotton fabric for sofa",
    },
    {
      title: "Jacquard",
      src: "/img/jaquard_img.jpg",
      alt: "Jacquard fabric for sofa",
    },
    {
      title: "Performance",
      src: "/img/performance_img.jpg",
      alt: "Performance fabric for sofa",
    },
    {
      title: "Decor Fabric",
      src: "/img/decor_fabric.jpeg",
      alt: "Decor fabric for sofa",
    },
  ];

  /* ================= SPECIALITIES ================= */

  const speciality = [
    {
      title: "Custom Reupholstery",
      desc: "Perfect measurement, cutting and stitching according to your sofa design.",
      icon: <FaCut />,
    },
    {
      title: "Foam & Cushion Repair",
      desc: "Replace old, damaged or sagging foam with comfortable high-density foam.",
      icon: <FaCouch />,
    },
    {
      title: "Wide Fabric Selection",
      desc: "Choose from velvet, suede, linen, chenille, cotton and many more options.",
      icon: <FaPalette />,
    },
    {
      title: "Premium Finish",
      desc: "Neat finishing, strong stitching and attention to every detail.",
      icon: <FaShieldAlt />,
    },
  ];

  /* ================= WHATSAPP ================= */

  const openWhatsApp = (message) => {
    window.open(
      `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(message)}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <>
      <Navbar />

      {/* =====================================================
          HERO SECTION
      ===================================================== */}

      <section className="services-section fabric-page-hero">
        <div className="container">
          <div className="row align-items-center g-5">

            {/* ================= LEFT CONTENT ================= */}

            <div className="col-lg-6">
              <div className="hero-content">

                <span className="services-label">
                  PREMIUM SOFA REUPHOLSTERY
                </span>

                <h1 className="fabric-hero-title">
                  Fabric Change &amp;
                  <span> Reupholstery</span>
                  <br />
                  Service in Noida
                </h1>

                <p className="hero-description">
                  Give your old sofa a completely fresh and luxurious look
                  with our professional fabric change and reupholstery
                  service in Noida. We use premium fabrics, quality foam
                  and expert craftsmanship for a perfect finish.
                </p>

                <p className="hero-description fabric-second-text">
                  Choose from velvet, suede, linen, chenille, leatherette,
                  jacquard and many more fabric options.
                </p>

                {/* ================= BUTTONS ================= */}

                <div className="hero-actions">

                  <a
                    href={`tel:${PHONE}`}
                    className="hero-btn hero-btn-primary"
                  >
                    <FaPhone />

                    <span>
                      <strong>Call Now</strong>
                      <small>{PHONE}</small>
                    </span>
                  </a>

                  <button
                    type="button"
                    className="hero-btn hero-btn-whatsapp"
                    onClick={() =>
                      openWhatsApp(
                        "Hi RK Sofa Works, I need sofa fabric change and reupholstery service in Noida."
                      )
                    }
                  >
                    <FaWhatsapp />
                    <span>WhatsApp Us</span>
                    <FaArrowRight />
                  </button>

                </div>

                {/* ================= TRUST POINTS ================= */}

                <div className="hero-trust-list">

                  <div className="hero-trust-item">
                    <span>
                      <FaCheckCircle />
                    </span>
                    <p>Premium Fabrics</p>
                  </div>

                  <div className="hero-trust-item">
                    <span>
                      <FaCheckCircle />
                    </span>
                    <p>Expert Stitching</p>
                  </div>

                  <div className="hero-trust-item">
                    <span>
                      <FaCheckCircle />
                    </span>
                    <p>Doorstep Service</p>
                  </div>

                  <div className="hero-trust-item">
                    <span>
                      <FaCheckCircle />
                    </span>
                    <p>Affordable Price</p>
                  </div>

                </div>

              </div>
            </div>

            {/* ================= RIGHT IMAGE ================= */}

            <div className="col-lg-6">

              <div className="hero-image-area fabric-image-area">

                <div className="hero-image-wrapper">

                  <img
                    src="/img/fabric_change.png"
                    alt="Sofa Fabric Change and Reupholstery Service in Noida"
                    className="hero-sofa-image"
                  />

                  <div className="hero-image-overlay"></div>

                </div>

                {/* TOP BADGE */}

                <div className="experience-badge">

                  <div className="experience-icon">
                    <FaCut />
                  </div>

                  <div>
                    <strong>Premium</strong>
                    <span>Fabric Collection</span>
                  </div>

                </div>

                {/* QUALITY CARD */}

                <div className="quality-card">

                  <div className="quality-icon">
                    <FaShieldAlt />
                  </div>

                  <div>
                    <strong>Expert Finish</strong>
                    <span>Professional Stitching</span>
                  </div>

                </div>

                {/* BOTTOM CARD */}

                <div className="sofa-service-card">

                  <div className="service-card-icon">
                    <FaCouch />
                  </div>

                  <div>
                    <strong>Complete Reupholstery</strong>
                    <span>Fabric • Foam • Stitching</span>
                  </div>

                </div>

              </div>

            </div>

          </div>
        </div>
      </section>

      {/* =====================================================
          SPECIALITIES
      ===================================================== */}

      <section className="services-section fabric-specialities">
        <div className="container">

          <div className="services-header">

            <span className="services-label">
              OUR SPECIALITIES
            </span>

            <h2>
              Complete Fabric Change
              <span> Solution</span>
            </h2>

            <p>
              From fabric selection to final stitching, our team takes care
              of every detail to give your sofa a premium new appearance.
            </p>

            <div className="services-line"></div>

          </div>

          <div className="services-grid fabric-speciality-grid">

            {speciality.map((item) => (
              <article
                className="service-card fabric-speciality-card"
                key={item.title}
              >

                <div className="fabric-speciality-icon">
                  {item.icon}
                </div>

                <div className="service-content">

                  <div className="service-title-row">

                    <h3>{item.title}</h3>

                    <FaCheckCircle className="service-check" />

                  </div>

                  <p>{item.desc}</p>

                </div>

              </article>
            ))}

          </div>

        </div>
      </section>

      {/* =====================================================
          FABRIC COLLECTION
      ===================================================== */}

      <section className="services-section fabric-collection">
        <div className="container">

          <div className="services-header">

            <span className="services-label">
              FABRIC COLLECTION
            </span>

            <h2>
              Choose Your Perfect
              <span> Fabric</span>
            </h2>

            <p>
              Select a fabric that matches your home's style, comfort
              and overall interior design.
            </p>

            <div className="services-line"></div>

          </div>

          <div className="services-grid fabric-grid">

            {fabric.map((item) => (
              <article
                className="service-card fabric-card"
                key={item.title}
              >

                <div className="service-image">

                  <img
                    src={item.src}
                    alt={item.alt}
                    loading="lazy"
                  />

                  <div className="service-image-overlay"></div>

                </div>

                <div className="service-content fabric-card-content">

                  <div className="service-title-row">

                    <h3>{item.title}</h3>

                    <FaCheckCircle className="service-check" />

                  </div>

                  <p>
                    Premium quality fabric suitable for sofa
                    reupholstery and furniture restoration.
                  </p>

                  <button
                    type="button"
                    className="service-enquire-btn"
                    onClick={() =>
                      openWhatsApp(
                        `Hi RK Sofa Works, I am interested in ${item.title} fabric for my sofa. Please share details and pricing.`
                      )
                    }
                  >

                    <FaWhatsapp />

                    <span>
                      Enquire About Fabric
                    </span>

                    <FaArrowRight className="service-arrow" />

                  </button>

                </div>

              </article>
            ))}

          </div>

        </div>
      </section>

      {/* =====================================================
          PRICING
      ===================================================== */}

      <section className="services-section fabric-pricing">
        <div className="container">

          <div className="services-header">

            <span className="services-label">
              PRICING
            </span>

            <h2>
              Approximate Fabric Change
              <span> Pricing</span>
            </h2>

            <p>
              Final price may vary depending on sofa size, fabric,
              foam condition and repair requirements.
            </p>

            <div className="services-line"></div>

          </div>

          <div className="row g-4">

            {/* ================= SINGLE SEATER ================= */}

            <div className="col-md-4">

              <div className="pricing-card">

                <span className="pricing-badge">
                  BASIC
                </span>

                <h3>Single-Seater</h3>

                <p>Basic fabric change</p>

                <h2>₹2,499–₹3,999</h2>

                <div className="pricing-divider"></div>

                <ul>

                  <li>
                    <FaCheckCircle />
                    Fabric removal &amp; fitting
                  </li>

                  <li>
                    <FaCheckCircle />
                    Basic stitching
                  </li>

                  <li>
                    <FaCheckCircle />
                    Foam inspection
                  </li>

                </ul>

                <a
                  href={`tel:${PHONE}`}
                  className="pricing-btn"
                >
                  <FaPhone />
                  Get Quote
                </a>

              </div>

            </div>

            {/* ================= THREE SEATER ================= */}

            <div className="col-md-4">

              <div className="pricing-card pricing-card-popular">

                <span className="pricing-popular">
                  POPULAR
                </span>

                <span className="pricing-badge">
                  PREMIUM
                </span>

                <h3>3-Seater Sofa</h3>

                <p>Mid-range fabric</p>

                <h2>₹6,999–₹10,999</h2>

                <div className="pricing-divider"></div>

                <ul>

                  <li>
                    <FaCheckCircle />
                    Premium stitching
                  </li>

                  <li>
                    <FaCheckCircle />
                    Foam replacement optional
                  </li>

                  <li>
                    <FaCheckCircle />
                    Pickup &amp; delivery
                  </li>

                </ul>

                <button
                  type="button"
                  className="pricing-btn"
                  onClick={() =>
                    openWhatsApp(
                      "Hi RK Sofa Works, I need a quote for 3-seater sofa fabric change."
                    )
                  }
                >
                  <FaWhatsapp />
                  WhatsApp Quote
                </button>

              </div>

            </div>

            {/* ================= L SHAPE ================= */}

            <div className="col-md-4">

              <div className="pricing-card">

                <span className="pricing-badge">
                  LUXURY
                </span>

                <h3>L-Shape / Sectional</h3>

                <p>Premium fabric</p>

                <h2>₹12,999+</h2>

                <div className="pricing-divider"></div>

                <ul>

                  <li>
                    <FaCheckCircle />
                    Detailed measurements
                  </li>

                  <li>
                    <FaCheckCircle />
                    On-site assessment
                  </li>

                  <li>
                    <FaCheckCircle />
                    Premium stitching
                  </li>

                </ul>

                <button
                  type="button"
                  className="pricing-btn"
                  onClick={() =>
                    openWhatsApp(
                      "Hi RK Sofa Works, I need a quote for L-shape sofa fabric change."
                    )
                  }
                >
                  <FaWhatsapp />
                  Get Custom Quote
                </button>

              </div>

            </div>

          </div>

        </div>
      </section>

      {/* =====================================================
          CTA
      ===================================================== */}

      <section className="services-section fabric-cta-section">

        <div className="container">

          <div className="services-bottom">

            <div className="services-bottom-content">

              <div>

                <span>
                  GIVE YOUR SOFA A NEW LOOK
                </span>

                <h3>
                  Ready to Change Your Sofa Fabric?
                </h3>

                <p>
                  Send us photos of your sofa on WhatsApp and get
                  a quick estimate from our experts.
                </p>

              </div>

              <button
                type="button"
                className="services-main-btn"
                onClick={() =>
                  openWhatsApp(
                    "Hi RK Sofa Works, I want to change my sofa fabric. I am sharing sofa photos for an estimate."
                  )
                }
              >
                <FaWhatsapp />
                Send Sofa Photos
                <FaArrowRight />
              </button>

            </div>

          </div>

        </div>

      </section>

      {/* ================= OTHER SECTIONS ================= */}

      <Review />
      <Offer />
      <Location />
      <Footer />
    </>
  );
}